import { AbpTitleStrategy } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';

/**
 * Workaround para bug do @abp/ng.core 8.3.4: o effect() de troca de idioma no
 * construtor do AbpTitleStrategy chama updateTitle(this.routerState) mesmo
 * antes da 1a navegacao terminar, quando routerState ainda e undefined.
 * O buildTitle(undefined) do Angular Router entao le snapshot.root e estoura
 * "Cannot read properties of undefined (reading 'root')".
 */
@Injectable()
export class SafeTitleStrategy extends AbpTitleStrategy {
  override updateTitle(routerState: RouterStateSnapshot): void {
    if (!routerState) return;
    super.updateTitle(routerState);
  }
}
